// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__21A4G","left":"InfoRow_left__3c_FL"};